/* ==========================================================================
   Bastion Armor — scroll-driven hero
   Vanilla port of the design's requestAnimationFrame logic (tickAssembly /
   tickOrbit / tickVault). Element lookups use [data-ba="name"] in place of
   the original React refs.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Smoothstep between a and b, clamped to 0..1 */
  function W(p, a, b) {
    var x = Math.min(1, Math.max(0, (p - a) / (b - a)));
    return x * x * (3 - 2 * x);
  }
  function L(a, b, t) { return a + (b - a) * t; }

  function Hero(root) {
    this.root = root;
    this.concept = root.getAttribute('data-concept') || 'assembly';
    this.mx = 0;
    this.my = 0;
    this.raf = 0;
    this.cache = {};
    this.onMouse = this.onMouse.bind(this);
    this.loop = this.loop.bind(this);
  }

  Hero.prototype.el = function (name) {
    if (!(name in this.cache)) {
      this.cache[name] = this.root.querySelector('[data-ba="' + name + '"]');
    }
    return this.cache[name];
  };

  Hero.prototype.onMouse = function (e) {
    this.mx = e.clientX / window.innerWidth - 0.5;
    this.my = e.clientY / window.innerHeight - 0.5;
  };

  Hero.prototype.start = function () {
    window.addEventListener('mousemove', this.onMouse, { passive: true });
    this.raf = requestAnimationFrame(this.loop);
  };

  Hero.prototype.loop = function (t) {
    this.raf = requestAnimationFrame(this.loop);
    this.tick(t);
  };

  Hero.prototype.tick = function (t) {
    var wrap = this.root;
    var vh = window.innerHeight;
    var p = Math.min(1, Math.max(0, window.scrollY / Math.max(1, wrap.offsetHeight - vh)));

    var hint = this.el('hint');
    if (hint) hint.style.opacity = p < 0.02 ? '1' : '0';

    if (this.concept === 'orbit') this.tickOrbit(p, t);
    else if (this.concept === 'vault') this.tickVault(p, t);
    else this.tickAssembly(p, t);
  };

  /* Shared: the closing headline block fades up into place */
  Hero.prototype.setFinal = function (name, w) {
    var el = this.el(name);
    if (!el) return;
    el.style.opacity = w;
    el.style.transform = 'translateY(' + L(30, 0, w) + 'px)';
    el.style.pointerEvents = w > 0.5 ? 'auto' : 'none';
  };

  Hero.prototype.tickAssembly = function (p, t) {
    var scene = this.el('scene');
    if (!scene) return;

    var wB = W(p, 0.12, 0.30);
    var wA = W(p, 0.36, 0.56);
    var wT = W(p, 0.62, 0.82);
    var wF = W(p, 0.86, 0.97);
    var seat = W(p, 0.60, 0.80);

    var base = Math.min(1, window.innerWidth / 620, window.innerHeight / 960);
    var caseH = Math.min(380, window.innerHeight * 0.50);
    var targetH = caseH * 0.63 * 0.92 * 0.92;
    var seatScale = Math.max(0.28, targetH / (520 * base));
    var finShrink = L(1, 0.72, wF);
    var sc = base * L(0.98, 1.04, W(p, 0, 0.6)) * L(1, seatScale, seat) * finShrink;

    var introDy = L(window.innerHeight * 0.17, 0, W(p, 0, 0.16));
    var liftF = L(0, window.innerHeight * 0.16, wF);
    var dy = introDy - liftF;

    var ry = (L(-16, 20, W(p, 0, 0.6)) + this.mx * 7 + Math.sin(t / 2600) * 2) * L(1, 0, seat);
    var rx = (L(7, -4, W(p, 0, 0.6)) - this.my * 5) * L(1, 0.15, seat);

    scene.style.transform =
      'translateY(' + dy + 'px) scale(' + sc + ') rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';

    var fw = this.el('floatWrap');
    if (fw) fw.style.animationPlayState = seat > 0.5 ? 'paused' : 'running';

    var back = this.el('lyBack');
    if (back) {
      back.style.transform = 'translateZ(' + L(-460, -16, wB) + 'px) translateY(' + L(70, 0, wB) + 'px)';
      back.style.opacity = Math.min(1, wB * 1.6);
    }
    var bum = this.el('lyBumper');
    if (bum) {
      bum.style.transform = 'translateZ(6px) scale(' + L(1.4, 1, wB) + ')';
      bum.style.opacity = wB;
    }
    var cs = this.el('lyCase');
    if (cs) {
      cs.style.transform = 'translateZ(' + L(430, 34, wA) + 'px)';
      cs.style.opacity = wA * 0.97;
    }
    var csb = this.el('lyCaseB');
    if (csb) {
      csb.style.transform = 'translateZ(' + L(-120, -46, wA) + 'px)';
      csb.style.opacity = wA * 0.8;
    }
    var sh = this.el('shine');
    if (sh) {
      var ws = W(p, 0.46, 0.60);
      sh.style.transform = 'translateX(' + L(-220, 320, ws) + '%) rotate(14deg)';
      sh.style.opacity = wA;
    }
    var tr = this.el('lyTravel');
    if (tr) {
      tr.style.opacity = wT;
      tr.style.transform =
        'translate(-50%,-50%) translateY(' + (L(34, 0, wT) - liftF) + 'px) scale(' + L(0.86, 1, wT) * finShrink + ')';
    }

    var self = this;
    function fade(name, win, out, dir) {
      var el = self.el(name);
      if (!el) return;
      el.style.opacity = win * (1 - out);
      el.style.transform = 'translateX(' + dir * L(26, 0, win) + 'px)';
    }
    fade('annBack', wB, W(p, 0.30, 0.36), 1);
    fade('annAcrylic', wA, W(p, 0.56, 0.62), -1);

    var h0 = this.el('h0');
    if (h0) {
      var o = 1 - W(p, 0.05, 0.13);
      h0.style.opacity = o;
      h0.style.transform = 'translateY(' + L(0, -34, 1 - o) + 'px)';
    }
    this.setFinal('hF', wF);

    var glow = this.el('glow');
    if (glow) glow.style.opacity = 0.3 + 0.55 * Math.max(wT * 0.45, wF);

    var ws2 = [wB, wA, wT, wF];
    for (var i = 0; i < 4; i++) {
      var step = this.el('pr' + i);
      if (!step) continue;
      var next = ws2[i + 1] === undefined ? 0 : ws2[i + 1];
      var on = ws2[i] > 0.35 && (i === 3 ? true : next < 0.35);
      step.classList.toggle('is-on', on);
    }
  };

  Hero.prototype.tickOrbit = function (p, t) {
    var ring = this.el('ring');
    if (!ring) return;

    var scw = Math.min(1, window.innerWidth / 700, window.innerHeight / 720);
    var rot = -p * 380;
    ring.style.transform = 'rotateY(' + rot + 'deg)';

    var R = Math.min(430, window.innerWidth * 0.42);
    var wF = W(p, 0.82, 0.97);

    for (var i = 0; i < 4; i++) {
      var el = this.el('oc' + i);
      if (!el) continue;
      var ang = (i * 90 + rot) % 360;
      var face = Math.cos(ang * Math.PI / 180);
      el.style.transform =
        'rotateY(' + i * 90 + 'deg) translateZ(' + R + 'px) rotateY(' + -(i * 90 + rot) + 'deg)';
      el.style.opacity = Math.max(0, face) * (1 - W(p, 0.7, 0.88)) * (p > 0.04 ? 1 : W(p, 0.02, 0.05));
    }

    var slab = this.el('oSlab');
    if (slab) {
      var dy = L(window.innerHeight * 0.08, 0, W(p, 0, 0.14)) - L(0, window.innerHeight * 0.1, wF);
      slab.style.transform =
        'translateY(' + dy + 'px) scale(' + scw * L(0.88, 1.05, W(p, 0, 1)) + ') rotateY(' +
        (Math.sin(t / 1900) * 14 + this.mx * 10 + L(-8, 8, W(p, 0, 1))) + 'deg) rotateX(' + -this.my * 6 + 'deg)';
    }

    var h = this.el('hO0');
    if (h) {
      var o = 1 - W(p, 0.05, 0.14);
      h.style.opacity = o;
      h.style.transform = 'translateY(' + L(0, -34, 1 - o) + 'px)';
    }
    this.setFinal('hOF', wF);

    var glow = this.el('glow');
    if (glow) glow.style.opacity = 0.3 + 0.6 * wF;
  };

  Hero.prototype.tickVault = function (p, t) {
    var door = this.el('vDoor');
    if (!door) return;

    var wSpin = W(p, 0.04, 0.34);
    var wOpen = W(p, 0.38, 0.62);
    var wSlab = W(p, 0.55, 0.8);
    var wF = W(p, 0.82, 0.97);

    var wheel = this.el('vWheel');
    if (wheel) wheel.style.transform = 'rotate(' + wSpin * 640 + 'deg)';

    /* The door is centred with margins, not a transform — keep it that way so
       translateZ/scale compose cleanly. */
    door.style.transform = 'translateZ(' + L(0, 900, wOpen) + 'px) scale(' + L(1, 1.6, wOpen) + ')';
    door.style.opacity = 1 - W(p, 0.5, 0.62);

    var g = this.el('vGlow');
    if (g) g.style.opacity = W(p, 0.3, 0.6) * 0.9 + wF * 0.1;

    var slab = this.el('vSlab');
    if (slab) {
      var scw = Math.min(1, window.innerWidth / 640, window.innerHeight / 720);
      slab.style.opacity = wSlab;
      slab.style.transform =
        'translateY(' + L(46, 0, wSlab) + 'vh) scale(' + scw * L(0.85, 1, wSlab) + ') rotateY(' +
        (this.mx * 10 + Math.sin(t / 2600) * 3) + 'deg)';
    }

    var h = this.el('hV0');
    if (h) {
      var o = 1 - W(p, 0.05, 0.14);
      h.style.opacity = o;
      h.style.transform = 'translateY(' + L(0, -34, 1 - o) + 'px)';
    }
    this.setFinal('hVF', wF);
  };

  /* ---------------------------------------------------------------- init -- */
  function initHero() {
    var root = document.querySelector('[data-ba="heroWrap"]');
    if (!root || reduced) return;
    new Hero(root).start();
  }

  /* Sticky nav — the source flipped these styles inside the same RAF tick;
     a scroll listener is enough and costs nothing when the hero is absent. */
  function initNav() {
    var nav = document.querySelector('[data-ba="nav"]');
    if (!nav) return;
    var apply = function () { nav.classList.toggle('is-stuck', window.scrollY > 40); };
    apply();
    window.addEventListener('scroll', apply, { passive: true });
  }

  /* Reveal-on-scroll — the source marked these with data-rv="1" */
  function initReveal() {
    var items = document.querySelectorAll('[data-rv]');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-rv');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-rv');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  /* Smooth in-page scrolling for the nav / CTA jump links */
  function initJumps() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-ba-jump]') : null;
      if (!trigger) return;
      var sel = trigger.getAttribute('data-ba-jump');
      if (sel === 'top') {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
        return;
      }
      var target = document.getElementById(sel);
      if (!target) return;
      e.preventDefault();
      if (window.BastionCart) window.BastionCart.close();
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - 60,
        behavior: reduced ? 'auto' : 'smooth'
      });
    });
  }

  function boot() {
    initNav();
    initHero();
    initReveal();
    initJumps();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
